import React from 'react';
import {
  buildPersonAvatarUrl,
  getPersonInitial,
  normalizePersonRole,
} from '../../avatar/PersonAvatar';
import AccountAvatarTrigger from './AccountAvatarTrigger';
import { artistGenderAvatarBg } from './avatarColor';

export default function EventChatAvatarNode({
  kind = 'person',
  role = 'admin',
  title = '',
  name = '',
  picture = '',
  gender = '',
  imageRoot = '',
  buildAssetUrl,
  appendVariant,
  onClick,
  fallbackStyle = null,
  fallbackContent = null,
  className = 'chat-avatar',
  clickableClassName = 'chat-avatar--clickable',
  initialClassName = 'chat-avatar-initial',
  announcementClassName = 'chat-avatar chat-avatar-announce',
  announcementToneClassName = '',
  announcementIconClass = 'fa-solid fa-bullhorn',
  showAdminIdentityBadge = true,
}) {
  if (kind === 'announcement') {
    const toneClass = String(announcementToneClassName || '').trim();
    return (
      <div
        className={`${announcementClassName}${toneClass ? ` ${toneClass}` : ''}`}
        title={title || 'お知らせ'}
        aria-hidden="true"
      >
        <i className={announcementIconClass} aria-hidden="true" />
      </div>
    );
  }

  const clickable = typeof onClick === 'function';
  const resolvedName = String(name || '');
  const resolvedRole = normalizePersonRole(role);
  const url = buildPersonAvatarUrl({
    role: resolvedRole,
    profilePicture: picture,
    variant: 'proxy',
    root: imageRoot || '',
  }) ||
    (picture ? appendVariant?.(buildAssetUrl?.(imageRoot, picture), 'proxy') : '');
  const initial = getPersonInitial(resolvedName, '?');
  const mergedClassName = [
    className,
    resolvedRole === 'admin' ? 'is-admin' : '',
    resolvedRole === 'admin' && showAdminIdentityBadge ? 'is-admin-identity' : '',
    clickable ? clickableClassName : '',
  ].filter(Boolean).join(' ');
  const style = fallbackStyle || (resolvedRole === 'admin'
    ? {
      background: 'var(--admin-avatar-fallback-bg)',
      color: 'var(--admin-avatar-fallback-text)',
    }
    : {
      backgroundColor: artistGenderAvatarBg(gender),
    });
  const fallback = fallbackContent != null
    ? fallbackContent
    : <span className={initialClassName}>{initial}</span>;

  if (url) {
    return (
      <AccountAvatarTrigger
        className={mergedClassName}
        title={title || resolvedName}
        imageUrl={url}
        imageAlt={resolvedName}
        style={style}
        fallback={fallback}
        onClick={clickable ? onClick : undefined}
      />
    );
  }

  return (
    <AccountAvatarTrigger
      className={mergedClassName}
      title={title || resolvedName}
      style={style}
      onClick={clickable ? onClick : undefined}
      fallback={fallback}
    />
  );
}
